import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input } from '@angular/core';
import { ServiceStateEnum } from '@mwe/constants';
import { ServiceStateEnumExporter } from '@mwe/ui/shared';
import { StaticContentService } from '@mwe/services';
import { TranslateDirective } from '@ngx-translate/core';
import { BasicCardComponent } from '../cards/basic-card/basic-card.component';
import { BulletComponent } from './bullet.component';
import { InlineNotificationComponent } from '../inline-notification/inline-notification.component';
import { InfoboxComponent } from '../infobox/infobox.component';

@Component({
  selector: 'mwe-bullet-confirmation-view',
  templateUrl: './bullet-confirmation-view.component.html',
  imports: [TranslateDirective, BasicCardComponent, BulletComponent, InlineNotificationComponent, InfoboxComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BulletConfirmationViewComponent extends ServiceStateEnumExporter {
  private staticContentService = inject(StaticContentService);

  @Input() errorMsgKey: string;
  @Input() errorTitleKey = 'error.service.default.title';
  @Input() bulletStateMap: Map<string, ServiceStateEnum> = new Map();
  @Input() bulletLabelMap: Map<string, string> = new Map();
  @Input() bulletStateIconMap: Map<string, Map<ServiceStateEnum, string>> = new Map();
  @Input() bulletStateClassMap: Map<string, Map<ServiceStateEnum, string>> = new Map();
  @Input() bulletTitleMap: Map<string, string> = new Map();
  @Input() bulletIds: string[];
  @Input() bulletTranslateMap: Map<string, any> = new Map();
  @Input() generalTranslateValues: any;
  @Input() alertPlaceholders: Map<string, any> = new Map();
  @Input() state: ServiceStateEnum;
  @Input() successMsgKey: string;
  @Input() bottomMsgKey: string;
  @Input() workInProgressMsgKey: string;
  @Input() successImageSrc = '/assets/img/success-animation_no_text.gif';
  @Input() isSuccessImageVisible = true;
  @Input() forcedLastLine = false;
}
